import intlTelInput from 'intl-tel-input';

export function getCountriesForSpecificCase(caseName) {
  if (caseName === 'mobile-money-countries') {
    const form = document.querySelector('#charge-mobile-money-form');
    if (form) {
      // Parse and return the mobile money supported countries from the form data attribute
      return JSON.parse(form.dataset.mobileMoneySupportedCountries);
    }
  }
  return [];
}

export let iti;

export function initializeIntlTelInput() {
  var input = document.querySelector("input[type=tel]");
  if (!input) return;

  var inputTarget = document.querySelector(input.dataset.target);
  var specificCountries = input.dataset.specificCountries;
  var defaultCountry = input.dataset.defaultCountry || "bj";
  var onlyCountries = specificCountries ? getCountriesForSpecificCase(specificCountries) : undefined;

  var options = {
    initialCountry: "auto",
    geoIpLookup: function (success, failure) {
      $.get("https://ipinfo.io?token=8ba4bdbd451b4f", function () { }, "jsonp").always(function (resp) {
        var countryCode = (resp && resp.country) ? resp.country : defaultCountry;

        // Check if the country code is in the allowed countries list when we have restrictions
        if (onlyCountries && onlyCountries.length > 0 && !onlyCountries.includes(countryCode.toLowerCase())) {
          // If not in the list, use the default country
          countryCode = defaultCountry.toLowerCase();
        }

        success(countryCode);
      });
    },
    preferredCountries: [],
    loadUtils: () => import("intl-tel-input/build/js/utils.js")
  };

  if (onlyCountries) {
    options.onlyCountries = onlyCountries;
  }

  iti = intlTelInput(input, options);

  var handleChange = function () {
    iti.promise.then(() => {
      inputTarget.value = iti.isValidNumber() ? iti.getNumber() : '';
    });
    return false;
  };

  input.addEventListener('change', handleChange);
  input.addEventListener('keyup', handleChange);
}

document.addEventListener("turbo:load", initializeIntlTelInput);
